import { toast, type ToastContent } from 'react-toastify';

const notify = (message: ToastContent, succes?: boolean): void => {
  if (succes) {
    toast.success(message, {
      closeOnClick: true,
      draggable: true,
      onClose: () => {
        toast.dismiss(message?.toString() ?? '');
      },
    });
    return;
  }

  toast.error(message, {
    closeOnClick: true,
    draggable: true,
    onClose: () => {
      toast.dismiss(message?.toString() ?? '');
    },
  });
};

export default notify;
